import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ForwarderService, PagerService, AlertService, CommonService, TableHeader,  AnnouncedfarePortList, OceanLine, OceanLineService, AnnouncedfarePortReqBody } from '../../services/index'

declare var $:any;
import _ from 'lodash';
import { Util } from '../../utils/index';

@Component({
  selector: 'announced-port',
  templateUrl: 'announced-port.html' 
})
export class AnnouncedPortContainer {
  getFarePortListSub:Subscription;
  updateFarePortStatusSub:Subscription;

  portList:Array<AnnouncedfarePortList>;
  tempPortList:Array<AnnouncedfarePortList>;
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();
  headerList:Array<TableHeader> = null;
  clickedHader:TableHeader;
  oceanLineList: OceanLine[] = [];

  reqList: AnnouncedfarePortReqBody[];

  getLocaleTime: Function = Util.getLocaleTime;

  @Output() headerSortedEmit: EventEmitter<any> = new EventEmitter();
  @Output() clearHeaderEmit: EventEmitter<any> = new EventEmitter();
  

  constructor(
    private fwdrService: ForwarderService, 
    private pagerService: PagerService, 
    private alertService:AlertService, 
    private commonService:CommonService,
    private oceanLineService:OceanLineService
  ) {

    // this.oceanLineList = this.oceanLineService.lineList;

    // if(_.isEmpty(this.oceanLineList)) {
    //   this.oceanLineService.lineListEe.subscribe(
    //     oceanLineList => {
    //       this.oceanLineList = oceanLineList;
    //     }
    //   );
    // }

    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempPortList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  }
  
  ngOnInit() {

    if(this.fwdrService.farePortSearchOption != null){
      this.searchOption = this.fwdrService.farePortSearchOption;
    }

    if(this.fwdrService.fwdrLinePager != null){
      this.pager = this.fwdrService.fwdrLinePager;
      this.search(this.pager.currentPage);
    }else{
      this.search(1);
    }

    if(this.fwdrService.fwdrLineHeader != null){
      this.headerList = this.fwdrService.fwdrLineHeader;
    }else{
      this.makeHeader();
    }
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'line', '선사', false));    
    this.headerList.push(new TableHeader(1, 'portCd', '포트 CD', true));    
    this.headerList.push(new TableHeader(2, 'portNm', '포트 이름', true));
    this.headerList.push(new TableHeader(3, 'location.name', 'Location Nm', true));  
    this.headerList.push(new TableHeader(4, 'location.locationCd', 'Location Cd', true));    
    this.headerList.push(new TableHeader(5, 'location.locationType', 'Location Type', true));    
    this.headerList.push(new TableHeader(6, 'location-selector', 'Location Selector', false));
    this.headerList.push(new TableHeader(7, 'insDtm', '입력날짜', true));
    this.headerList.push(new TableHeader(8, 'hideYn', '숨김처리', true));
    this.headerList.push(new TableHeader(9, 'edit', '수정', false));
    this.headerList.push(new TableHeader(10, 'del', '삭제', false));
  }

  ngOnDestroy(){
    if(this.getFarePortListSub) this.getFarePortListSub.unsubscribe();
    if(this.updateFarePortStatusSub) this.updateFarePortStatusSub.unsubscribe();
  }

  search(page){
    this.getFarePortListSub = this.fwdrService.getFarePortList(resp => {
        this.portList = resp;
        this.tempPortList = this.portList;
  
        if(this.fwdrService.fwdrLineClickedHeader != null){
          this.clickedHader = this.fwdrService.fwdrLineClickedHeader;
          
          if(this.clickedHader.orderBy.indexOf("ASC") > -1){
            this.clickedHader.orderBy = 'DESC';
          }else{
            this.clickedHader.orderBy = 'ASC';
          }
  
          this.commonService.headerClick(this.clickedHader, this.tempPortList);
        }
  
        this.conditionSearch(page);
      }
      
    );
  }
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.tempPortList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempPortList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    
  }

  selectLocation(event, port:AnnouncedfarePortList) {
    if(event == null) return;
    if(event.locationId == port.selectedLocationId) return;
    
    port.selectedLocationId = event.locationId;  
    port.selectedLocation = event;
    
    if(_.isEmpty(this.reqList)) {
      this.reqList = [];
    }

    let alreadyIn = null;
    if(!_.isEmpty(this.reqList)) {
      alreadyIn = _.find(this.reqList, {portMapId : port.portMapId});
    }

    if(alreadyIn != null) {
      alreadyIn.locationId = event.locationId;
    } else {
      let newReq = new AnnouncedfarePortReqBody();

      newReq.portMapId = port.portMapId;
      newReq.locationId = event.locationId;

      this.reqList.push(newReq);
    }
  }

  changeHideNo(event, port:AnnouncedfarePortList) {
    this.fwdrService.patchFarePortShow(port.portMapId, resp => {
      this.alertService.success('선사가 공개로 변경되었습니다.');
      port.hideYn = 'N';
    },
    err => {
      this.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
    })
  }

  changeHideYes(event, port:AnnouncedfarePortList) {
    this.fwdrService.patchFarePortHide(port.portMapId, resp => {
      this.alertService.success('선사가 숨김으로 변경되었습니다.');
      port.hideYn = 'Y';
    },
    err => {
      this.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
    })
  }

  editPort(event, port:AnnouncedfarePortList){
    event.stopPropagation();
    let that = this;
    let reqBody = [{portMapId : port.portMapId, locationId:port.selectedLocationId}];
    $.sweetModal.confirm("매핑된 Location을 변경하시겠습니까?", function() {
      that.fwdrService.postFarePortList(reqBody, resp => {
          that.alertService.success('Location 변경이 완료되었습니다.');
          port.location = port.selectedLocation;
          port.selectedLocation = null;
          if(!_.isEmpty(this.reqList)) {
            let findFwdrIndex = _.findIndex(this.reqList, {portMapId : port.portMapId});
            if(findFwdrIndex > -1) {
              this.reqList.splice(findFwdrIndex, 1);
            }
          }
        },
        err => {
          that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.')
        },
        () => {

        }
      );
    });
  }

  saveAll(event) {
    event.stopPropagation();
    let that = this;
    let reqBody = this.reqList;
    $.sweetModal.confirm("매핑된 Location을 변경하시겠습니까?", function() {
      that.fwdrService.postFarePortList(reqBody, resp => {
          that.alertService.success('Location 변경이 완료되었습니다.');
          that.search(that.pager.currentPage);
        },
        err => {
          that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.')
        },
        () => {

        }
      );
    });
  }

  deletePort(event, port:AnnouncedfarePortList) {
    event.stopPropagation();
    let that = this;
    let reqBody = [{portMapId : port.portMapId, locationId:null}];
    $.sweetModal.confirm("매핑된 Location을 삭제하시겠습니까?", function() {
      that.fwdrService.postFarePortList(reqBody, resp => {
          that.alertService.success('Location 삭제가 완료되었습니다.');
          port.location = port.selectedLocation;
          if(!_.isEmpty(this.reqList)) {
            let findFwdrIndex = _.findIndex(this.reqList, {portMapId : port.portMapId});
            if(findFwdrIndex > -1) {
              this.reqList.splice(findFwdrIndex, 1);
            }
          }
        },
        err => {
          that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.')
        },
        () => {

        }
      );
    });
  }

  conditionSearch(page?:number){
    if(_.isEmpty(this.portList)) return;
    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    let statusCd = this.searchOption.conditionType;
    let hideYnCd = this.searchOption.hideType;
    this.tempPortList = _.map(_.filter(this.portList,
      (port:AnnouncedfarePortList) => {
        if(!keyword) return true;
        else if (_.upperCase(port.portCd ? port.portCd : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(port.portMapId ? port.portMapId : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(port.portNm ? port.portNm : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(port.location ? port.location.cntryCd : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(port.location ? port.location.name : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(port.location ? port.location.locationCd : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(port.location ? port.location.locationId : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.tempPortList = _.map(_.filter(this.tempPortList,
      (port:AnnouncedfarePortList) => {
        if(statusCd == 'ALL') return true;
        else if(statusCd == 'YES') {
          if(port.location && port.location.locationId) return true;
          else return false;
        }
        else if(statusCd == 'NO') {
          if(!port.location || (port.location && !port.location.locationId)) return true;
          else return false;
        }
      }));

    this.tempPortList = _.map(_.filter(this.tempPortList, 
      (port:AnnouncedfarePortList) => {
        if(hideYnCd == 'ALL') return true;
      else if(hideYnCd == 'YES') {
        if(port.hideYn == 'Y') return true;
        else return false;
      }
      else if(hideYnCd == 'NO') {
        if(port.hideYn == 'N') return true;
        else return false;
      }
    }));
    this.setPage(page == null || page == undefined ? 1 : page);
    this.commonService.clearOrderByHeader(this.headerList);
  }
  
  selectConditionType(event){
    this.searchOption.conditionType = event;
    this.conditionSearch();
  }

  selectHideType(event) {
    this.searchOption.hideType = event;
    this.conditionSearch();
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch();
  }

  headerClick(header:TableHeader){
    this.clickedHader = header;
    this.fwdrService.farePortClickedHeader = header;
    this.commonService.headerClick(header, this.tempPortList);
  }
}

class SearchOption {
  conditionText:string;
  conditionType:string = 'ALL';
  hideType:string = 'ALL';
}



// WEBPACK FOOTER //
// ./src/app/containers/announced-fare/announced-port.ts